import {CorpusGroup, LearnerMoreGroup, LearnerToolsGroup} from '../groups';
import {HomeLink, LearnerAppLink, LegalMentionsLink, LearnerAssignmentsLink, OwnProgressTrackingLink} from '../links';
import {NavigationContext} from '../navigation.context';
import {SiteMapLink} from "../links/site-map.link";

export const LearnerMenu = (context: NavigationContext) => [
    HomeLink(context),
    LearnerAssignmentsLink(context),
    LearnerMoreGroup(context),
    CorpusGroup(context),
    LearnerToolsGroup(context),
    OwnProgressTrackingLink(context),
    LearnerAppLink(context),
    LegalMentionsLink(context),
    SiteMapLink(context, 'learner'),
];

